import { Animated, Platform, useWindowDimensions } from 'react-native';
import {
  StackNavigationOptions,
  TransitionPresets,
} from '@react-navigation/stack';
import { useMemo } from 'react';

export const useFullScreenOptions = () => {
  const windowDimensions = useWindowDimensions();

  return useMemo(
    (): StackNavigationOptions => ({
      ...Platform.select({
        default: TransitionPresets.ModalTransition,
        ios: {
          ...TransitionPresets.ModalSlideFromBottomIOS,
          // Custom interpolator that uses the window height instead of
          // the screen height passed by react-navigation in order to fix
          // animation jankiness when leaving the screen
          // https://github.com/react-navigation/react-navigation/blob/%40react-navigation/stack%406.3.1/packages/stack/src/TransitionConfigs/CardStyleInterpolators.tsx#L69
          cardStyleInterpolator: ({ current, inverted }) => {
            const translateY = Animated.multiply(
              current.progress.interpolate({
                extrapolate: 'clamp',
                inputRange: [0, 1],
                outputRange: [windowDimensions.height, 0],
              }),
              inverted,
            );

            return {
              cardStyle: {
                transform: [{ translateY }],
              },
            };
          },
        },
      }),
      gestureEnabled: false,
    }),
    [windowDimensions],
  );
};
